import React from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

// Compact "More" button that reveals a longer description in a popover —
// keeps cards small on phones while keeping the detail one tap away.
export default function InfoMore({ text, label, light = false, side = "top", testid = "info-more" }) {
  const { t } = useTranslation();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className={`inline-flex items-center gap-1 text-xs font-medium rounded-full px-2 py-1 transition-colors ${
            light ? "text-white/75 hover:text-white hover:bg-white/10" : "text-[#5F7161] hover:bg-[#EFF1EC]"
          }`}
        >
          <Info size={12} strokeWidth={2} />
          {label || t("common.more")}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        className="max-w-[260px] text-sm text-[#2C332A] leading-relaxed rounded-2xl border-[#E6E2D8]"
      >
        {text}
      </PopoverContent>
    </Popover>
  );
}
